import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './styles/main.css';

const container = document.getElementById('root');
if (!container) {
  // A missing root is a build or deploy fault, not a runtime condition to
  // recover from. Fail loudly rather than rendering nothing and looking fine.
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
